import request from './http';

// 分页查询字典列表
export const getPageList = data => {
    return request({
        url: '/auth/mkSysDict/findPageList?pageNo='+data.pageNo+"&pageSize="+data.pageSize+"&dictName="+data.dictName+"&dictType="+data.dictType,
        // url: '/Mikael/mkSysDict/findPageList?pageNo='+data.pageNo+'&pageSize='+data.pageSize,
        method: 'get',
    })
}

// 删除字典信息
export const deleteDictInfo = data => {
    return request({
        url: '/Mikael/mkSysDict/deleteDict/'+data,
        method: 'delete'
    })
}

// 新增/修改字典数据
export const changeDictInfo = data => {
    return request({
        url: '/Mikael/mkSysDict/addOrUpdate',
        method: 'post',
        data
    })
}
